export enum GardenType {
    PERSONAL = 'personal',
    MASTER = 'master'
}